import { atom } from 'jotai';
import type { SearchItem } from './types';

interface Selection {
  item: SearchItem;
  /** Increments on every pick, so picking the same item again restarts its marker. */
  id: number;
}

export const selectionAtom = atom<Selection | null>(null);

export const selectSearchItemAtom = atom(null, (get, set, item: SearchItem) => {
  set(selectionAtom, { item, id: (get(selectionAtom)?.id ?? 0) + 1 });
});

export const clearSearchSelectionAtom = atom(null, (_get, set) => set(selectionAtom, null));
